import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Auth } from "aws-amplify";
import { isEmpty } from "lodash";
import axios from "axios";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import { ReactComponent as DownArrowSvg } from "assets/images/heylime-layout/pricing-arrow.svg";
import Alert from "components/shared/common/alert";
import useWindowSize from "components/shared/WindowResize";
import { setIsLoading } from "redux/loader/action";

const DeleteAccount = ({ history }) => {
  const dispatch = useDispatch();
  const { height } = useWindowSize();
  const currentUser =
    useSelector((state) => state.gameReducer.currentUser) || {};
  const isManager = currentUser.team?.manager === currentUser.userId;
  const lastMember = currentUser.team?.count === 1;
  const users = currentUser.team?.users.filter(
    (user) => user.Username !== currentUser.team?.manager && user
  );

  const [email, setEmail] = useState("");
  const [teamDropdown, setTeamDropdown] = useState(false);
  const [selectedManager, setSelectedManager] = useState({});

  const handleIsLoading = (value) => dispatch(setIsLoading(value));
  const togglePlanDropdown = () => setTeamDropdown(!teamDropdown);

  const deleteUser = async () => {
    if (email === currentUser.email) {
      handleIsLoading(true);
      try {
        if (currentUser.team) {
          let url = process.env.REACT_APP_REMOVE_PLAYER_MYTEAM;
          await axios.post(url, {
            promoCode: currentUser.team.id,
            userId: currentUser.userId
          });
        }
        await Auth.deleteUser();
        history.push("/delete_account_success");
        Alert(200, "Deleted Successfully.");
      } catch (error) {
        console.log("Error while deleting account: ", error);
      } finally {
        handleIsLoading(false);
      }
    } else {
      Alert(400, "Please enter correct email.");
    }
  };

  const handleDeleteAccount = async () => {
    if (isManager) {
      if (lastMember) {
        await deleteUser();
      } else {
        if (isEmpty(selectedManager)) {
          Alert(400, "Please select a new team manager.");
        } else {
          try {
            handleIsLoading(true);
            const url = process.env.REACT_APP_CHANGE_MANAGER;
            await axios.post(url, {
              team_code: currentUser.team.id,
              current_manager_id: currentUser.team.manager,
              new_manager_id: selectedManager.Username
            });
            await deleteUser();
          } catch (error) {
            handleIsLoading(false);
          }
        }
      }
    } else {
      await deleteUser();
    }
  };

  return (
    <div className={`delete-account-main ${height < 750 ? "height750" : ""}`}>
      <h2 className="title delete">
        Delete
        <br />
        Account?
      </h2>
      <p className="desc delete">
        Are you sure you want to completely remove your account? Your account
        will be permanently removed from the platform.
      </p>
      <span className="desc">Signed in as: </span>
      <span className="desc bold-text">{currentUser.email}</span>

      <div
        className={`delete-bottom-content ${height < 750 ? "height750" : ""}`}
      >
        {lastMember && (
          <p className="desc delete">
            {`You are the last member of (${currentUser.team.description}), deleting your account will
            archive your team.`}
          </p>
        )}
        {isManager && !lastMember && (
          <Dropdown isOpen={teamDropdown} toggle={togglePlanDropdown}>
            <DropdownToggle caret>
              {selectedManager.name || "Select New Team Manager"}
              <DownArrowSvg />
            </DropdownToggle>
            <DropdownMenu>
              {users.map((user, index) => (
                <DropdownItem
                  key={index}
                  onClick={() => setSelectedManager(user)}
                >
                  {user.name}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        )}
        <p className="hint-text">{`Type "${currentUser.email}" to confirm`}</p>
        <input
          name="email"
          type="email"
          value={email}
          className="input-div delete"
          placeholder="Enter here..."
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          className="onboarding-button delete"
          onClick={handleDeleteAccount}
        >
          Continue
        </button>
        <p className="bottom-text">
          Didn’t mean to delete account?{" "}
          <span className="bold-text" onClick={() => history.goBack()}>
            Go Back
          </span>
        </p>
      </div>
    </div>
  );
};

export default DeleteAccount;
